import { createEntityAdapter } from '@reduxjs/toolkit';
import { TeamGroup } from '../../domain/interfaces/team-group';

const groupsAdapter = createEntityAdapter<TeamGroup>({
  selectId: (group) => group.id,
  sortComparer: (a, b) => new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf(),
});

export default groupsAdapter;
